// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import utilsModel from "../../../../../engines/libs/utilsModel";
import UserDataManage from "../../../model/UserDataManage";
import MilitaryRecruitOfficerItem from "./MilitaryRecruitOfficerItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class MilitaryRecruitOfficerPopLayer extends BasePopUpLayer {

    @property(cc.Prefab)
    itemPrefab: cc.Prefab = null;
    @property(cc.ScrollView)
    scrollView: cc.ScrollView = null;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        
        this.initLayer();
    }

    initLayer(bFroce: boolean = false) {
        let militaryOfficerDataManage = UserDataManage.instance.militaryOfficerDataManage;
        // let militaryOfficerData = militaryOfficerDataManage.militaryOfficerData;
        let officeList = militaryOfficerDataManage.getOfficeList(bFroce);

        this.scrollView.content.removeAllChildren();
        for (let o of officeList) {
            let nodeItem = cc.instantiate(this.itemPrefab);
            let scirpt = nodeItem.getComponent(MilitaryRecruitOfficerItem);
            scirpt.setData(o);
            this.scrollView.content.addChild(nodeItem);
        }
    }

    onClickRefresh() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        let militaryOfficerDataManage = UserDataManage.instance.militaryOfficerDataManage;
        let officeList = militaryOfficerDataManage.getResidueOffice();
        if (officeList.length <= 0) {
            O1HD.getModules().uiControlModule.showMessageBox("暂时没有武将可供招募");
            return;
        }
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.initLayer(true);
        },()=>{

        },null,"观看广告刷新武将列表")
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
        this._carryData.parent.destroyNode();
    }

    // update (dt) {}
}
